__turbopack_context__.v({
  "feeText": "AdminFee-module__Ag445q__feeText",
  "isPdp": "AdminFee-module__Ag445q__isPdp",
  "wrapper": "AdminFee-module__Ag445q__wrapper",
});
